<template>
<div class="travel2023">
    <div class="top-ornament">
        
    </div>
    <div class="cont">
        <p class="only-pc">在明媚的5月，有阳光的日子不宅家！一场野餐或户外烧烤、周边一日游、骑行、公园散步、周末遛娃、度假屋等，约克论坛邀您一起记录精彩瞬间，还有机会获得惊喜哦~ </p>
        <div class="main-title">活动主题</div>
        <div class="text main-space">
            活动主题 <strong>#一起春游去#</strong>，发布帖子即成功参与活动。
        </div>
        <div class="main-title">参与方式</div>
        <div class="ps-text">发帖可以参考以下两个方向：</div>
        <div class="text">
           <strong>01 记录春日的野餐：</strong>
           阳光明媚，带上朋友家人狗子来一场户外烧烤或野餐，拍照记录欢笑！
        </div>
        <div class="text mrg-space">
            <strong>02 晒晒春天遛娃的照片：</strong>春天来了，多户外走走，你喜欢带娃去哪玩呢？翻翻手机里的照片，看看哪些你们曾经“打卡”的地方，给论坛里的麻麻们推荐下吧
        </div>
        <div class="main-title only-pc">活动奖励/评选方式</div>
        <div class="text only-pc">
           优质奖：10名，每人奖励10加币礼品卡（或等值微信红包） 
        </div>
        
        <div class="text only-pc">
            结合帖子内容的文字图片或视频质量，以及帖子的浏览量、回复量、点赞量，在精选作品中选择10名获奖者。 每日精选参与奖：不限量；被设置为精华帖，有机会获得每日精选参与奖，可获得5-10元不等微信红包。
        </div>
    </div>
    <a href="https://forum.yorkbbs.ca/detail/54389c6a-26e5-4e11-8f2d-146b128c2b95?topic=chat" class="paly-detail" target="_blank">活动详情&gt;</a>
</div>
</template>
<script>
export default {
    name:'TravelIntroduction',
    
}
</script>
<style lang="less" scoped>
.travel2023{
    position: relative; z-index: 2;
    &::before{
        position: absolute; left: 0; top:22px; right: 8px ; bottom: 0; content: ''; z-index: -2; background: #9bdc1e;  border-radius: 10px;
    }
    &:after{
        position: absolute; left: 8px; top: 14px; right: 0; bottom: 8px; content:''; background: url(https://media2.imgyb.xyz/media/v1/image/98e169347f4e6f35d26e1c8e79c36ec3.jpeg) repeat left top; z-index: -1; border-radius: 10px;
    }
    .top-ornament{
        position: absolute; z-index: 2; left: 50px; right: 50px; top: 0; height: 33px; background: url(https://media6.imgyb.xyz/media/v1/image/d274aba79fc6d3a9c7d18e5253b60d34.png) repeat-x;
    }
    .cont{
        padding: 58px 50px 50px;
        p{
            font-size: 18px; line-height: 30px; color: #333; margin-bottom: 20px;
        }
        .main-title{font-size: 16px; line-height: 24px; color: #F25029; font-weight: bold; margin-bottom: 5px;}
        .text{font-size: 16px; line-height: 26px;}
        .ps-text{font-size: 14px; line-height: 20px; color: #333; margin-bottom: 5px;}
        .main-space{margin-bottom: 20px;}
        .mrg-space{margin-bottom: 12px;}
    }
    .paly-detail{
        position: absolute; z-index: 2; right: 50px; bottom: 40px; color: #F25029; font-size: 16px; line-height: 24px;
    }
}
@media screen and (max-width:768px){
    .travel2023{
        .top-ornament{background-size: 19px 16px; left: 25px; right: 25px;}
        &:before{top: 14px;}
        &:after{top: 6px;}
        .cont{
            padding: 28px 25px 30px;
        }
        .paly-detail{bottom: 20px;}
    }
}
</style>